<template>
  <div v-loading="showFlag">
    <t-card>
      <t-form
        ref="userFormData"
        :model="userFormData"
        domain="userFormData"
        label-position="right"
        label-width="100px"
        class="userInfoForm"
      >
        <t-row>
          <t-col :span="12">
            <t-form-item :label="$t('resource.userMst.usrCode')" prop="userId">
              <t-input
                v-model="userFormData.userId"
                style="width: 97%"
                clearable
                maxLength="20"
                :disabled="disabled"
              ></t-input>
            </t-form-item>
          </t-col>

          <t-col :span="12">
            <t-form-item :label="$t('resource.userMst.usrPwd')" prop="password">
              <t-input
                v-model="userFormData.password"
                type="password"
                style="width: 97%"
                maxLength="15"
                show-password
                autocomplete="new-password"
              ></t-input>
            </t-form-item>
          </t-col>
        </t-row>
        <t-row>
          <t-col :span="12">
            <t-form-item
              :label="$t('resource.userMst.usrName')"
              prop="userName"
            >
              <t-input
                v-model="userFormData.userName"
                style="width: 97%"
                clearable
                maxLength="20"
              ></t-input>
            </t-form-item>
          </t-col>
          <t-col :span="12">
            <t-form-item
              :label="$t('resource.userMst.nickName')"
              prop="nickName"
            >
              <t-input
                v-model="userFormData.nickName"
                style="width: 97%"
                clearable
                maxLength="15"
              ></t-input>
            </t-form-item>
          </t-col>
        </t-row>

        <t-row>
          <t-col :span="12">
            <t-form-item
              :label="$t('resource.userMst.contraction')"
              prop="contraction"
            >
              <t-input
                v-model="userFormData.contraction"
                style="width: 97%"
                clearable
                maxLength="3"
              ></t-input>
            </t-form-item>
          </t-col>
          <t-col :span="12">
            <t-form-item
              :label="$t('resource.userMst.department')"
              prop="department"
            >
              <t-select
                placeholder=""
                class="commonDialog"
                v-model="userFormData.department"
                clearable
                style="width: 97%"
              >
                <t-option
                  v-for="item in departmentList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </t-option>
              </t-select>
            </t-form-item>
          </t-col>
        </t-row>

        <t-row>
          <t-col :span="12">
            <t-form-item
              :label="$t('resource.userMst.telephone')"
              prop="telephone"
            >
              <t-input
                v-model="userFormData.telephone"
                style="width: 97%"
                maxLength="15"
                clearable
              ></t-input>
            </t-form-item>
          </t-col>
          <t-col :span="12">
            <t-form-item :label="$t('resource.userMst.usrMail')" prop="email">
              <t-input
                v-model="userFormData.email"
                style="width: 97%"
                maxLength="50"
                clearable
              ></t-input>
            </t-form-item>
          </t-col>
        </t-row>

        <t-row>
          <t-col :span="12">
            <t-form-item :label="$t('resource.userMst.usrFlag')">
              <t-select
                placeholder=""
                class="commonDialog"
                v-model="userFormData.deleteFlg"
                style="width: 97%"
              >
                <t-option
                  v-for="item in useFlgList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </t-option>
              </t-select>
            </t-form-item>
          </t-col>
          <!-- MFA認証 -->
          <t-col :span="12">
            <t-form-item :label="$t('resource.userMst.MFA_ENABLED')">
              <t-switch v-model="userFormData.mfaEnabledBool"></t-switch>
            </t-form-item>
          </t-col>
        </t-row>

        <t-form-item class="float-right">
          <t-button
            v-show="!isAddFlg"
            id="setCustomers"
            round
            type="primary"
            class="dialogButton_150_40"
            @click="setRoles"
          >
            <i class="el-icon-link"></i>
            {{ $t("resource.userManager.setRoles") }}
          </t-button>

          <t-button
            v-show="!isAddFlg"
            id="setCustomers"
            round
            type="primary"
            class="dialogButton_150_40"
            @click="setCustomers"
          >
            <i class="el-icon-link"></i>
            {{ $t("resource.userManager.setCustomers") }}
          </t-button>

          <!-- 確定  -->
          <t-button
            v-if="isAddFlg"
            round
            type="warning"
            class="dialogButton_confirm_120_40"
            @click="entryOrChangeUsrData"
          >
            <i class="el-icon-check"></i>
            {{ $t("resource.sys.sure") }}</t-button
          >

          <!-- 变更 -->
          <t-button
            v-else
            round
            type="warning"
            class="dialogButton_confirm_120_40"
            @click="entryOrChangeUsrData"
          >
            <i class="el-icon-check"></i>{{ $t("resource.sys.sure") }}</t-button
          >
        </t-form-item>
      </t-form>
    </t-card>
  </div>
</template>

<script>
import {
  ShowUserCustomerDialog,
  ShowUserRoleDialog,
} from "@/components/Dialog";
import { t } from "@/locales";
import service from "@/services/userManage";
import {
  cmpBasicData,
  formatDateStrToString,
  formatDateToString,
} from "@/utils/comFunction";
import { contractionList, STR_ONE, STR_ZERO } from "@/utils/const";
import { Message, Modal } from "@tellus/component";

//import { encryptByMd5 } from "@/utils/crypto";
export default {
  name: "UserDialog",

  props: {
    isAdd: {
      type: Boolean,
      default: false,
    },
    rowData: {
      Type: Object,
    },
    useFlgs: {
      Type: Object,
    },
    usrRoles: {
      Type: Object,
    },
  },
  data() {
    return {
      //ユーザー情報
      userFormData: {
        userId: "",
        password: "",
        userName: "",
        nickName: "",
        contraction: "",
        department: "",
        telephone: "",
        email: "",
        usrStartDate: "",
        usrEndDate: "",
        deleteFlg: "0",
        mfaEnabledBool: true,
        // 角色
        userRoles: [],
      },

      //新規フラグ
      isAddFlg: false,

      // 角色List
      flrUserRole: [],

      //使用区分
      useFlgList: [],
      //部門
      departmentList: [],

      usrRolesList: [],

      disabled: false,

      showFlag: false,

      // 読み込み回数
      numLoads: 1,

      // 比較用基本情報
      cmpBasicResult: {},
    };
  },
  created() {
    this.showFlag = true;
    this.isAddFlg = this.isAdd;
    this.useFlgList = this.useFlgs;

    //部門のリスト取得
    service.InitUserDepartmentList().then((res) => {
      this.$nextTick(() => {
        //部門
        this.departmentList = res.departmentList;

        // 角色List
        this.usrRolesList = res.flrUserRole;

        //新規の場合
        if (this.isAddFlg) {
          //使用開始日:システム日
          this.dateInit();
        } else {
          this.userFormData.userId = this.rowData.userId;
        }

        this.init();
      });
    });
  },

  mounted() {},

  methods: {
    entryOrChangeUsrData() {
      if (this.inputCheck()) {
        this.userFormData.updateUser = localStorage.getItem("userId");
        this.cmpBasicResult.updateUser = localStorage.getItem("userId");

        // Domain Check
        this.$refs.userFormData.validate((valid) => {
          if (valid) {
            //新规または変更
            const requestData = {
              ...this.userFormData,
              mfaEnabled: this.userFormData.mfaEnabledBool ? STR_ONE : STR_ZERO,
              LockFlg: 0,
            };

            if (this.isAddFlg) {
              requestData.password = requestData.password; //encryptByMd5(requestData.userId);
              service.Entry(requestData, () => {
                this.isAddFlg = false;
                this.numLoads = 1;
                this.init();
              });
            } else {
              service.Change(requestData, () => {
                this.init();
                this.numLoads = 1;
              });
            }
          }
        });
      }
    },

    init() {
      //編集の場合
      if (!this.isAddFlg) {
        this.disabled = true;

        //ユーザー情報の取得
        service
          .GetUserInfoDataById(this.userFormData.userId)
          .then((res) => {
            this.userFormData = res.userInfo;

            contractionList.key = res.contractionList;

            //日付の変換
            if (res.UsrStartDate) {
              this.userFormData.usrStartDate = formatDateStrToString(
                res.UsrStartDate
              );
            }
            if (res.UsrEndDate) {
              this.userFormData.usrEndDate = formatDateStrToString(
                res.UsrEndDate
              );
            }
            this.disabled = true;
          })
          .catch((err) => {
            if (err.data != null) {
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
            } else {
              Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
            }
          })
          .finally(() => {
            this.showFlag = false;

            // 比較用基本情報の初期化
            this.initComparisonInfo();
          });
      } else {
        this.userFormData.userId = "";

        // ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 start↓
        this.userFormData.mfaEnabledBool = true;
        // ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 end↑
        //ユーザー情報の取得
        service
          .GetUserInfoDataById(this.userFormData.userId)
          .then((res) => {
            contractionList.key = res.contractionList;
          })
          .catch((err) => {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          })
          .finally(() => {
            this.showFlag = false;

            // 比較用基本情報の初期化
            this.initComparisonInfo();
          });
      }
    },

    // 比較用基本情報の初期化
    initComparisonInfo() {
      if (this.numLoads === 1) {
        this.cmpBasicResult = JSON.parse(JSON.stringify(this.userFormData));

        // 読み込み回数 + 1
        this.numLoads = this.numLoads + 1;
      }
    },

    inputCheck() {
      // 使用開始日>=使用終了日の場合
      if (
        this.userFormData.usrStartDate &&
        this.userFormData.usrEndDate &&
        this.userFormData.usrStartDate > this.userFormData.usrEndDate
      ) {
        Message.showError(t("message.VALIDATION.DATE_RANGE_NOT_CORRECT"));
        return false;
      }
      return true;
    },

    dateInit() {
      var systemDate = new Date();
      // 開始日
      this.userFormData.usrStartDate = formatDateToString(systemDate);
    },

    //得意先設定
    setCustomers() {
      //console.log("this.userId---" + JSON.stringify(this.userFormData.UserId));
      ShowUserCustomerDialog(
        { userId: this.userFormData.userId },
        t("resource.userManager.setCustomers")
      );
    },

    //権限設定
    setRoles() {
      //console.log("this.userId---" + JSON.stringify(this.userFormData.UserId));
      ShowUserRoleDialog(
        { userId: this.userFormData.userId },
        t("resource.userManager.addRoles")
      );
    },

    // ダイアログを閉じる
    onCancel() {
      if (!cmpBasicData(this.cmpBasicResult, this.userFormData)) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },
  },
};
</script>

